// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_3QoxzLwMeV2SzhqDCY3p51","container":"_1vthFyo3d_AyUTLT5u7GeP"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/LogoLoading/styles.css
// module id = 2899
// module chunks = 0